<template>
  <div class="l-lr-layout">
    
    <div class="left">
      <slot name='left' />
    </div>  

    <div class="right">
      <slot name='right' />
    </div>
  
  </div>
</template>

<script>
export default {
  name: 'l-lr-layout'
}
</script>
<style lang="scss" scoped>
.left,
.right{
  display: inline-block;
}


</style>
